import React, { useContext, useState } from 'react';
import DepositCss from '../css/DepositCss';
import { useNavigate } from 'react-router-dom';
import { Context } from '../Context/Context';
import { Flip, toast } from 'react-toastify';
import { AddGames } from '../Api/AddGames';
import { Helmet } from 'react-helmet';


export default function AddGame() {
  const navigate = useNavigate();
  const [gameName, setGameName] = useState('');
  const [shortName, setShortName] = useState('');
  const { setLoad, setLoadColor, setSessionDetail } = useContext(Context);

  const handleAddGame = async () => {
    if (!gameName.trim() || shortName.length === 0) {
      toast.error("Please enter a game name", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Flip,
      });
      return;
    }

    setLoad(true);
    setLoadColor("#434343");

    const gameData = {
      username: JSON.parse(localStorage.getItem('userinfo'))?.username,
      user_id: JSON.parse(localStorage.getItem('userinfo'))?.userId,
      game_name: gameName.trim(),
      short_name: shortName
    };

    try {
      // Replace with real API call
      console.log("Game Data to Submit:", gameData);
      const res = await AddGames(gameData);
      if (res.data.status) {
        setSessionDetail(prev => ({
          ...prev,
          user_games: res.data.data.user_games
        }));
        toast.success("Game added successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Flip,
        });

        navigate("/game");
      } else {
        toast.error(res.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Flip,
        });
      }
    } catch (error) {
      toast.error("Something went wrong", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Flip,
      });
    } finally {
      setLoad(false);
    }
  };

  return (
    <DepositCss>
      <Helmet>
        {/* Page Title */}
        <title>Add Game | Manage Matka Satta Bazar Games | Matka Jantri</title>

        {/* SEO Description */}
        <meta
          name="description"
          content="Add and manage Matka Satta Bazar games like Delhi Bazar, Desawar, Shree Ganesh, Ghaziabad, and more. Keep track of your betting games easily on MatkaJantri."
        />

        {/* SEO Directives */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://pushpabetfair.com/add-game" />

        {/* Favicon and Icons */}
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

        {/* Mobile Optimization */}
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />

        {/* Open Graph */}
        <meta property="og:title" content="Add Game | Manage Matka Satta Bazar Games | MatkaJantri" />
        <meta
          property="og:description"
          content="Add and manage Matka Satta Bazar games like Delhi Bazar, Desawar, Shree Ganesh, Ghaziabad, and more. Keep track of your betting games easily on MatkaJantri."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://pushpabetfair.com/add-game" />
        <meta property="og:image" content="https://app.matkajantri.com/JantriImage/Logo.png" />
      </Helmet>

      <div className="w-100 fullpage">
        <div className="w-3">
          <div className="back-top">
            <i className="fa-solid fa-chevron-left" onClick={() => navigate("/game")}></i>
          </div>
          <div className="w-100 text-center d-flex">
            <button className="addFunds">
              <i className="fa-solid fa-gamepad"></i> Add Game
            </button>
          </div>
          <div className="w-100 px-3">
            <div className="mb-3 w-100">
              <label className="form-label">Game Name (Full Name)<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                placeholder="Required"
                className="form-control ps-2"
                value={gameName}
                onChange={(e) => setGameName(e.target.value)}
              />
            </div>
            <div className="mb-3 w-100">
              <label className="form-label">Game Name (Short Name)<span style={{ color: 'red' }}>*</span></label>
              <input
                type="text"
                placeholder="Required"
                className="form-control ps-2"
                value={shortName}
                onChange={(e) => setShortName(e.target.value)}
              />
            </div>

            <div className="text-center">
              <button className="submit-btn support-btn" onClick={handleAddGame}>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </DepositCss>
  );
}
